/**
 * Initialize Segment/ Analytics.js, and store the 'messageId' that comes from each page call that we make
 * the original function above was misspelled, so once all sites move over to this new one we'll remove the old one
 * functionality remains the same.
 *
 * @param {string} segmentToken
 *
 */
export const initializeSegment = (segmentToken) => {
  // The following block was taken from segments website: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/
  // eslint-disable-next-line
  var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey=segmentToken;;analytics.SNIPPET_VERSION="4.15.3";
    analytics.load(segmentToken);
    analytics.page();
  }

  // Analytics Middleware Documentation: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/middleware/
  analytics.addSourceMiddleware(({ payload, next }) => {
    if (payload.obj.type === 'page') {
      // every time a "trackPage" call is made, we want to store the messageId that is returned.
      // we'll use this to link "page"" events to "track" events
      window.sessionStorage.setItem('segmentPageMessageId', payload.obj.messageId);
    }
    next(payload);
  });
};

export default {
  /**
   * Initalize Segment/ Analytics.js, and store the 'messageId' that comes from each page call that we make
   *
   * @deprecated use initializeSegment named export instead
   * @param {string} segmentToken
   */
  initalizeSegment(segmentToken) {
    /* eslint-disable */
    // The following block was taken from segments website: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/
    var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey=segmentToken;;analytics.SNIPPET_VERSION="4.15.3";
      analytics.load(segmentToken);
      analytics.page();
    }
    /* eslint-enable */

    // Analytics Middleware Documenation: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/middleware/
    analytics.addSourceMiddleware(({ payload, next }) => {
      if (payload.obj.type === 'page') {
        // everytime a "trackPage" call is made, we want to store the messageId that is returned (we'll use this to link "page"" events to "track" events)
        window.sessionStorage.setItem('segmentPageMessageId', payload.obj.messageId);
      }
      next(payload);
    });
  },
  /**
   * When windows.analytics is available, collect various user properties to be
   * delivered for threeflow analytics (Intercom, log rocket, etc).
   *
   * @param {object} userInfo
   */
  identify(userInfo = {}) {
    if (window.analytics) {
      let orgName;

      if (userInfo.broker) {
        ({ name: orgName } = userInfo.broker);
      } else if (userInfo.carrier) {
        ({ name: orgName } = userInfo.carrier);
      }

      const payload = {
        ...userInfo,
        org_name: orgName,
        roles: userInfo.roles ? userInfo.roles.map(({ name }) => name).join(', ') : '',
        Site: window.location.hostname.match(/^[a-z0-9]+/i)[0].toLowerCase(),
      };

      window.analytics.identify(userInfo.id, payload);
    }
  },
  /**
   * Track page view
   *
   * @param {string} route
   * @param {object} payload
   */
  trackPage(route, payload) {
    if (window.analytics) {
      window.analytics.page(route, payload);
    }
  },
  /**
   * Track custom event
   *
   * @param {string} eventName
   * @param {object} payload
   */
  trackEvent(eventName, payload) {
    if (window.analytics) {
      window.analytics.track(eventName, {
        broker_id: null,
        employer_id: null,
        project_id: null,
        project_product_id: null,
        product_type_id: null,
        product_id: null,
        carrier_id: null,
        document_id: null,
        project_products_container_id: null,
        rate_attribute_id: null,
        rate_value_id: null,
        plan_design_attribute_id: null,
        plan_design_value_id: null,
        user_broker_id: null,
        user_carrier_id: null,
        target_carrier_id: null,
        target_broker_id: null,
        target_user_id: null,
        target_email: null,
        ...payload,
        page_message_id: window.sessionStorage.getItem('segmentPageMessageId'), // add the stored "segmentPageMessageId" to each payload for every tracked event
      });
    }
  },
};
